module.exports = __webpack_public_path__ + "static/media/Xeleration_logo.726ce6ee.png";